export class PostalCodeDto {
    code!: string;
    city!: string;
    province!: string;
}